var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { mdiFlaskOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { useCroppedImage } from '../../../../hooks';
import BackgroundImage from '../../styles/BackgroundImage';
import buildImageProps from '../buildImageProps';
const SmallVirtualLabImage = (_a) => {
    var _b;
    var { image, placeholderImage } = _a, otherProps = __rest(_a, ["image", "placeholderImage"]);
    const { uncroppedImage, placeholderImageSrc } = buildImageProps(image, placeholderImage);
    const { imageSrc } = useCroppedImage((_b = uncroppedImage === null || uncroppedImage === void 0 ? void 0 : uncroppedImage.original) === null || _b === void 0 ? void 0 : _b.url, uncroppedImage === null || uncroppedImage === void 0 ? void 0 : uncroppedImage.crop, {
        placeholderImageSrc
    });
    const renderIcon = () => {
        if (!image || !imageSrc)
            return React.createElement(Icon, { path: mdiFlaskOutline, title: "Virtual Lab Icon" });
    };
    return (React.createElement(BackgroundImage.Small, Object.assign({ imageSrc: image ? imageSrc : undefined, "data-testid": "VirtualLabImage" }, otherProps), renderIcon()));
};
const MediumVirtualLabImage = (_a) => {
    var _b;
    var { image, placeholderImage } = _a, otherProps = __rest(_a, ["image", "placeholderImage"]);
    const { uncroppedImage, placeholderImageSrc } = buildImageProps(image, placeholderImage);
    const { imageSrc } = useCroppedImage((_b = uncroppedImage === null || uncroppedImage === void 0 ? void 0 : uncroppedImage.original) === null || _b === void 0 ? void 0 : _b.url, uncroppedImage === null || uncroppedImage === void 0 ? void 0 : uncroppedImage.crop, {
        placeholderImageSrc
    });
    const renderIcon = () => {
        if (!image || !imageSrc)
            return React.createElement(Icon, { path: mdiFlaskOutline, title: "Virtual Lab Icon" });
    };
    return (React.createElement(BackgroundImage.Medium, Object.assign({ imageSrc: image ? imageSrc : undefined, "data-testid": "VirtualLabImage" }, otherProps), renderIcon()));
};
const LargeVirtualLabImage = (_a) => {
    var _b;
    var { image, placeholderImage } = _a, otherProps = __rest(_a, ["image", "placeholderImage"]);
    const { uncroppedImage, placeholderImageSrc } = buildImageProps(image, placeholderImage);
    const { imageSrc } = useCroppedImage((_b = uncroppedImage === null || uncroppedImage === void 0 ? void 0 : uncroppedImage.original) === null || _b === void 0 ? void 0 : _b.url, uncroppedImage === null || uncroppedImage === void 0 ? void 0 : uncroppedImage.crop, {
        placeholderImageSrc
    });
    const renderIcon = () => {
        if (!image || !imageSrc)
            return React.createElement(Icon, { path: mdiFlaskOutline, title: "Virtual Lab Icon" });
    };
    return (React.createElement(BackgroundImage.Large, Object.assign({ imageSrc: image ? imageSrc : undefined, "data-testid": "VirtualLabImage" }, otherProps), renderIcon()));
};
export default {
    Small: SmallVirtualLabImage,
    Medium: MediumVirtualLabImage,
    Large: LargeVirtualLabImage
};
//# sourceMappingURL=index.js.map